<template>
  <v-app class="bg-color text-tatble th-stlye th-first th-last">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.SearchConsent") }}</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap fill-height justify-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-text>
                <v-layout row wrap justify-center>
                  <v-expansion-panels
                    flat
                    class="rounded-lg"
                    v-model="enablefilter"
                  >
                    <v-expansion-panel class="rounded-lg">
                      <v-expansion-panel-header>
                        <v-fade-transition leave-absolute>
                          <span style="font-size: 18px">{{
                            $t("consentlist.Specifysearchconditions")
                          }}</span>
                        </v-fade-transition>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-form ref="form">
                          <v-layout row wrap justify-center align-baseline>
                            <v-flex xs9 lg3 pa-2>
                              <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    hide-details
                                    color="#077893"
                                    clearable
                                    outlined
                                    dense
                                    v-model="FromDate"
                                    :label="$t('consentlist.submission')"
                                    persistent-hint
                                    append-icon="mdi-calendar-outline"
                                    v-bind="attrs"
                                    @blur="date = parseDate(FromDate)"
                                    v-on="on"
                                    @click:clear="ToDate = ''"
                                  >
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  locale="TH"
                                  color="#077893"
                                  v-model="date"
                                  no-title
                                  @input="menu1 = false"
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-menu
                                hide-details
                                ref="menu2"
                                v-model="menu2"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    hide-details
                                    color="#077893"
                                    clearable
                                    outlined
                                    dense
                                    v-model="ToDate"
                                    :label="$t('consentlist.to')"
                                    persistent-hint
                                    append-icon="mdi-calendar-outline"
                                    v-bind="attrs"
                                    @blur="date2 = parseDate2(ToDate)"
                                    v-on="on"
                                  >
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  locale="TH"
                                  color="#077893"
                                  v-model="date2"
                                  no-title
                                  @input="menu2 = false"
                                  :min="FromDate"
                                  :max="TodateMax"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-select
                                hide-details
                                v-model="SourceSystem"
                                :items="$t('consentlist.all')"
                                :label="$t('NewUpdate.text3')"
                                :rules="[
                                  (v) => !!v || $t('consentlist.rulessystem'),
                                ]"
                                color="#077893"
                                clearable
                                dense
                                outlined
                                append-icon="mdi-server-network"
                              >
                              </v-select>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-select
                                hide-details
                                color="#077893"
                                clearable
                                v-model="StatusSend"
                                :items="$t('consentlist.ItemsStatusConsent')"
                                :label="$t('Toolbar.consent')"
                                :rules="[
                                  (v) =>
                                    !!v || $t('consentlist.rulesStatusConsent'),
                                ]"
                                dense
                                outlined
                                append-icon="mdi-send-outline"
                              >
                              </v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap justify-center align-baseline>
                            <v-flex xs9 lg3 pa-2>
                              <v-select
                                hide-details
                                color="#077893"
                                clearable
                                item-value="PolicyId"
                                item-text="Title"
                                v-model="SelectPolicy"
                                :items="ItemsPolicy"
                                :label="$t('dashboard.policy')"
                                dense
                                outlined
                                append-icon="mdi-card-text-outline"
                              >
                              </v-select>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-select
                                hide-details
                                item-value="ConsentId"
                                item-text="HeaderConsent"
                                v-model="SelectConsent"
                                :items="ItemsConsentData"
                                :label="$t('Toolbar.consent')"
                                color="#077893"
                                clearable
                                dense
                                outlined
                                append-icon="mdi-card-text-outline"
                              >
                              </v-select>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-select
                                hide-details
                                color="#077893"
                                clearable
                                item-value="GroupId"
                                item-text="GroupName"
                                v-model="SelectConsentGroup"
                                :items="ItemsConsentGroup"
                                :label="$t('consentlist.groupC')"
                                dense
                                outlined
                                append-icon="mdi-card-text-outline"
                              >
                              </v-select>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-account-outline"
                                :label="$t('email.text8')"
                                dense
                                outlined
                                v-model="Name"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap justify-center align-baseline>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-account-tag-outline"
                                :label="$t('consentlist.UserId')"
                                dense
                                outlined
                                v-model="IDCardNumber"
                                color="#077893"
                                clearable
                              ></v-text-field>
                              <!-- <v-text-field
                             append-icon="mdi-account-cog-outline"
                            label="Biz ID"
                            dense
                            outlined
                            v-model="BizId"
                            color="#077893"
                            clearable
                          ></v-text-field> -->
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-account-tag-outline"
                                :label="$t('onechat.con4')"
                                dense
                                outlined
                                v-model="EmployeeId"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-account-cog-outline"
                                label="Username (ONE ID)"
                                dense
                                outlined
                                v-model="OneAccountId"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-passport"
                                :label="$t('NewUpdate.text4')"
                                dense
                                outlined
                                v-model="Passport"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap justify-center align-baseline>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-email-outline"
                                :label="$t('dashboard.email')"
                                dense
                                outlined
                                v-model="Email"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-card-account-phone-outline"
                                :label="$t('petition.text31')"
                                dense
                                outlined
                                v-model="Tel"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-identifier"
                                label="Session ID"
                                dense
                                outlined
                                v-model="Id"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs9 lg3 pa-2>
                              <v-text-field
                                hide-details
                                append-icon="mdi-ip-outline"
                                label="IP Address"
                                dense
                                outlined
                                v-model="Ip"
                                color="#077893"
                                clearable
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-layout row wrap justify-center>
                    <v-flex xs7 sm3 md3 lg2>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        @click="Fn_Search('false')"
                        :loading="LoadingSearch"
                      >
                        <v-icon left> mdi-magnify </v-icon>
                        {{ $t("consentlist.search") }}
                      </v-btn>
                    </v-flex>
                    <v-flex xs7 sm8 md4 lg3 :pl-3="$vuetify.breakpoint.mdAndUp">
                      <v-btn
                        color="green"
                        class="white--text"
                        :loading="loadCSV"
                        :disabled="loaddisCSV"
                        @click="Fn_DownloadCSV"
                      >
                        <v-icon dark> mdi-file-excel-outline </v-icon>
                        {{ $t("search.text1") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class="rounded-lg mt-5">
              <v-card-text>
                <v-layout row wrap align-center justify-start>
                  <v-flex my-3>
                    <b>
                      จำนวนความยินยอมที่ค้นพบ :
                      <v-chip v-if="TotalAll" label outlined color="#077893">{{
                        TotalAll
                      }}</v-chip
                      ><v-chip v-else label outlined color="#077893"
                        >0</v-chip
                      ></b
                    >
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-end>
                  <v-flex xs4 sm4 md4 lg4>
                    <v-select
                      v-model="ItemPerPage"
                      :items="itemsPage"
                      item-text="state"
                      item-value="count"
                      label="จำนวนแถวต่อหน้า"
                      dense
                      outlined
                      hide-details
                      color="#077893"
                      append-icon="mdi-clipboard-list"
                      @change="Fn_Search('true')"
                    ></v-select>
                    <!-- <v-select
                      hide-details
                      v-model="ItemPerPage"
                      :items="ItemPerPage"
                      label="จำนวนแถวต่อหน้า"
                      color="#077893"
                      dense
                      outlined
                      append-icon="mdi-clipboard-list"
                    >
                    </v-select> -->
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 sm6 md4 lg4>
                    <v-text-field
                      append-icon="mdi-magnify"
                      :label="$t('consentlist.search')"
                      v-model="Search"
                      dense
                      outlined
                      clearable
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-card outlined class="mt-n2">
                  <v-data-table
                    :headers="headers"
                    :items="ItemConsent"
                    hide-default-footer
                    :search="Search"
                    disable-sort
                    group-by="SourceSystem"
                    :items-per-page="ItemPerPage"
                  >
                    <template
                      v-slot:[`group.header`]="{ items, isOpen, toggle }"
                    >
                      <th
                        class="white--text"
                        colspan="20"
                        style="background-color: #077893 !important"
                      >
                        <v-icon dark @click="toggle"
                          >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
                        </v-icon>
                        {{ $t("consentlist.type") }} :
                        {{ items[0].SourceSystem }}
                      </th>
                    </template>
                    <template v-slot:[`item.SendId`]="{ item }">
                      <td class="text-center">
                        <div
                          class="text-center"
                          v-if="item.SendId === '' || item.SendId === null"
                        >
                          -
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === true"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                color="#077893"
                                style="cursor: pointer"
                                small
                                @click="Fn_CopyDetail(item.SendId)"
                                v-on="on"
                                >mdi-file-multiple-outline</v-icon
                              >
                            </template>
                            <span>{{ $t("consentlist.copy") }}</span>
                          </v-tooltip>
                          {{ item.SendId }}
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === false"
                        >
                          ...
                        </div>
                        <center>
                          <v-btn
                            icon
                            color="#077893"
                            @click="fn_seeEmailAnalysis(item)"
                            text
                            ><v-icon>{{
                              item.see_id === true
                                ? "mdi-eye-off"
                                : "mdi-eye-settings"
                            }}</v-icon>
                          </v-btn>
                        </center>
                      </td>
                    </template>
                    <template v-slot:[`item.Type`]="{ item }">
                      <div
                        v-if="item.Type == 'General' && $t('default') === 'th'"
                      >
                        <v-chip color="teal" small dark>
                          <v-icon small class="mr-1">mdi-text-box</v-icon>
                          ทั่วไป</v-chip
                        >
                      </div>
                      <div
                        v-if="item.Type == 'General' && $t('default') === 'en'"
                      >
                        <v-chip color="teal" small dark>
                          <v-icon small class="mr-1">mdi-text-box</v-icon>
                          General</v-chip
                        >
                      </div>
                      <div
                        v-else-if="
                          item.Type == 'Group' && $t('default') === 'th'
                        "
                      >
                        <v-chip color="indigo" small dark>
                          <v-icon small class="mr-1"
                            >mdi-text-box-multiple</v-icon
                          >
                          กลุ่ม</v-chip
                        >
                      </div>
                      <div
                        v-else-if="
                          item.Type == 'Group' && $t('default') === 'en'
                        "
                      >
                        <v-chip color="indigo" small dark>
                          <v-icon small class="mr-1"
                            >mdi-text-box-multiple</v-icon
                          >
                          Group</v-chip
                        >
                      </div>
                    </template>
                    <template v-slot:[`item.BusinessName`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.BusinessNameTh }}
                      </div>
                      <div v-else>
                        {{ item.BusinessNameEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.PolicyHeader`]="{ item }">
                      <v-tooltip
                        right
                        color="#077893"
                        v-if="item.PolicyHeader.length > 25"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            {{ item.PolicyHeader.slice(0, 25) }}
                          </div>
                        </template>
                        <span>{{ item.PolicyHeader }}</span>
                      </v-tooltip>
                      <div v-else>
                        {{ item.PolicyHeader }}
                      </div>
                    </template>
                    <template v-slot:[`item.ConsentName`]="{ item }">
                      <v-tooltip
                        right
                        color="#077893"
                        v-if="item.ConsentName.length > 39"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            {{ item.ConsentName.slice(0, 39) }}
                          </div>
                        </template>
                        <span>{{ item.ConsentName }}</span>
                      </v-tooltip>
                      <div v-else>
                        {{ item.ConsentName }}
                      </div>
                    </template>
                    <!-- <template v-slot:[`item.Cookie`]="{ item }">
                      <v-tooltip
                        right
                        color="#077893"
                        v-if="item.Cookie.length > 15"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            {{ item.Cookie.slice(0, 15) }}
                          </div>
                        </template>
                        <span>{{ item.Cookie }}</span>
                      </v-tooltip>
                      <div v-else-if="item.Cookie">
                        {{ item.Cookie }}
                      </div>
                    </template> -->
                    <template v-slot:[`item.SendAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.SendAt }}
                      </div>
                      <div v-else>
                        {{ item.SendAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.Status`]="{ item }">
                      <div v-if="item.Status === 'active'">
                        <v-chip color="green" small dark>
                          {{ $t("petition.text22v2") }}</v-chip
                        >
                      </div>
                      <div v-else-if="item.Status === 'unactive'">
                        <v-chip color="grey" small dark>
                          {{ $t("petition.text23") }}</v-chip
                        >
                      </div>
                      <div v-else-if="item.Status === 'expire'">
                        <v-chip color="black" small dark>
                          {{ $t("petition.text37") }}</v-chip
                        >
                      </div>
                      <div v-else-if="item.Status === 'action'">
                        <v-chip color="info" small dark>
                          {{ $t("petition.text44") }}</v-chip
                        >
                      </div>
                      <div v-else-if="item.Status === 'petition'">
                        <v-chip color="red" small dark>
                          {{ $t("petition.text45") }}</v-chip
                        >
                      </div>
                      <div v-else>
                        <v-chip color="warning" small dark>
                          {{ $t("petition.text24") }}</v-chip
                        >
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            icon
                            color="info"
                            @click="Fn_ViewDetail(item)"
                          >
                            <v-icon dark size="20" color="#077893">
                              mdi-text-box-search-outline
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-card>
                <v-pagination
                  @input="Fn_Search('true')"
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="LastPage"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </v-card-text>
            </v-card>
            <div v-if="loadingDownloadData">
              <OverlaySearch />
            </div>
            <DialogListDetail
              :show="DialogLitDetail"
              :dataConsent="SelectDetailConsent"
              @closeDialog="DialogLitDetail = false"
            />
            <DialogGeneralConsent
              :show="DialogGeneral"
              :_detail="DataConsent"
              @closeDialogDelete="DialogGeneral = false"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/SearchConsentList/DialogSearchConsentDetail.vue";
import DialogListDetail from "@/components/dialog/SearchConsentList/DialogSearchConsentListDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import { format } from "date-fns";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogGeneralConsent, OverlaySearch, DialogListDetail },
  data: (vm) => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    FromDate: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    ToDate: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    menu1: false,
    menu2: false,
    dark: false,
    DialogLitDetail: false,
    Policy: "",
    Consent: "",
    ConsentGroup: "",
    Page: 1,
    PageCount: 0,
    // ItemPerPage: 100,
    ItemConsent: [],
    PageDetail: [],
    From: null,
    To: null,
    LastPage: null,
    TotalAll: null,
    ItemCount: [],
    number: [],
    DepartmentId: [],
    enablefilter: 0,
    SelectDetailConsent: [],
    TodateMax: "",
    BizId: "",
    StatusSend: "null",
    DialogDelete: false,
    LoadingSearch: false,
    loadingDownloadData: false,
    tab: null,
    items: ["ความยินยอมทั่วไป", "ความยินยอมแบบกลุ่ม"],
    system: [
      { text: "ทั้งหมด", value: "null" },
      { text: "API", value: "API" },
      { text: "Onechat", value: "ONECHAT" },
      { text: "Email", value: "EMAIL" },
    ],
    SourceSystem: "null",
    DialogPetitionRequest: false,
    detail: "",
    Name: "",
    Email: "",
    Id: "",
    Ip: "",
    Tel: "",
    Search: "",
    OneAccountId: "",
    IDCardNumber: "",
    Passport: "",
    SelectPolicy: "",
    SelectConsent: "",
    SelectConsentGroup: "",
    ItemsPolicy: [],
    ItemsConsentData: [],
    ItemsConsentGroup: [],
    loadCSV: false,
    loaddisCSV: true,
    DataLoadCSV: [],
    DialogItem: [],
    DataConsent: [],
    DialogGeneral: false,
    PolicyHeader: "",
    EmployeeId: "",
    ItemPerPage: 100,
    itemsPage: [
      { state: "100", count: 100 },
      { state: "500", count: 500 },
      { state: "1000", count: 1000 },
    ],
  }),
  computed: {
    ...mapGetters(["Business"]),
    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          value: "no",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.Cnumber"),
          align: "left",
          value: "SendId",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.type"),
          align: "center",
          value: "Type",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.topic"),
          value: "PolicyHeader",
          align: "center",
          width: 150,
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.ConsentName"),
          value: "ConsentName",
          align: "center",
          width: 130,
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.NameShow"),
          value: "OwnerInputNameTh",
          align: "left",
          width: 180,
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.Email"),
          value: "Email",
          align: "left",
          width: 150,
          sortable: false,
        },
        // {
        //   text: this.$i18n.t("consentlist.Tag"),
        //   value: "Tag",
        //   align: "left",
        //   sortable: false,
        // },
        // {
        //   text: "One AccountId",
        //   value: "OneAccountId",
        //   align: "left",
        //   width: 100,
        //   sortable: false,
        // },
        // {
        //   text: "Username",
        //   value: "Username",
        //   align: "left",
        //   width: 60,
        //   sortable: false,
        // },

        // {
        //   text: this.$i18n.t("consentlist.Name"),
        //   value: "Name",
        //   align: "left",
        //   width: 60,
        //   sortable: false,
        // },
        // {
        //   text: this.$i18n.t("consentlist.Tel"),
        //   value: "Tel",
        //   align: "left",
        //   width: 60,
        //   sortable: false,
        // },
        // {
        //   text: "IP-Address",
        //   value: "IpAddress",
        //   align: "left",
        //   width: 100,
        //   sortable: false,
        // },
        // {
        //   text: this.$i18n.t("consentlist.Idcard"),
        //   value: "Idcard",
        //   align: "left",
        //   width: 100,
        //   sortable: false,
        // },
        // {
        //   text: this.$i18n.t("consentlist.Passport"),
        //   value: "Passport",
        //   align: "left",
        //   width: 100,
        //   sortable: false,
        // },
        // {
        //   text: "Cookie",
        //   value: "Cookie",
        //   align: "left",
        //   width: 100,
        //   sortable: false,
        // },
        // {
        //   text: this.$i18n.t("consentlist.NameReq"),
        //   value: "ReqNameTh",
        //   align: "left",
        //   width: 100,
        //   sortable: false,
        // },
        {
          text: this.$i18n.t("consentlist.DateApprove"),
          value: "SendAt",
          align: "center",
          width: 150,
          sortable: false,
        },
        {
          text: this.$i18n.t("petition.text14"),
          value: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.choicedetail"),
          value: "action",
          align: "center",
          sortable: false,
          scopedSlots: { customRender: "action" },
        },
      ];
    },
    // ItemConsent() {
    //   // Only include items where the 'visible' property is true
    //   return this.items.filter((item) => item.visible);
    // },
    _FromDate: {
      get() {
        if (this.FromDate === "" || this.FromDate === null) {
          return "null";
        } else {
          return format(new Date(this.FromDate), "yyyyMMdd");
        }
      },
    },
    _ToDate: {
      get() {
        if (this.ToDate === "" || this.ToDate === null) {
          return "null";
        } else {
          return format(new Date(this.ToDate), "yyyyMMdd");
        }
      },
    },
    _ConsentId: {
      get() {
        if (this.SelectConsent === "" || this.SelectConsent === null) {
          return "null";
        } else {
          return this.SelectConsent;
        }
      },
    },
    _PolicyId: {
      get() {
        if (this.SelectPolicy === "" || this.SelectPolicy === null) {
          return "null";
        } else {
          return this.SelectPolicy;
        }
      },
    },
    _GroupId: {
      get() {
        if (
          this.SelectConsentGroup === "" ||
          this.SelectConsentGroup === null
        ) {
          return "null";
        } else {
          return this.SelectConsentGroup;
        }
      },
    },
    _Email: {
      get() {
        if (this.Email === "" || this.Email === null) {
          return "null";
        } else {
          return this.Email;
        }
      },
    },
    _IDCardNumber: {
      get() {
        if (this.IDCardNumber === "" || this.IDCardNumber === null) {
          return "null";
        } else {
          return this.IDCardNumber;
        }
      },
    },
    _Name: {
      get() {
        if (this.Name === "" || this.Name === null) {
          return "null";
        } else {
          return this.Name;
        }
      },
    },
    _Passport: {
      get() {
        if (this.Passport === "" || this.Passport === null) {
          return "null";
        } else {
          return this.Passport;
        }
      },
    },
    _Tel: {
      get() {
        if (this.Tel === "" || this.Tel === null) {
          return "null";
        } else {
          return this.Tel;
        }
      },
    },
    _BizId: {
      get() {
        if (this.BizId === "" || this.BizId === null) {
          return "null";
        } else {
          return this.BizId;
        }
      },
    },
    _SourceSystem: {
      get() {
        if (this.SourceSystem === "" || this.SourceSystem === null) {
          return "null";
        } else {
          return this.SourceSystem;
        }
      },
    },
    _OneAccountId: {
      get() {
        if (this.OneAccountId === "" || this.OneAccountId === null) {
          return "null";
        } else {
          return this.OneAccountId;
        }
      },
    },
    _IdSession: {
      get() {
        if (this.Id === "" || this.Id === null) {
          return "null";
        } else {
          return this.Id;
        }
      },
    },
    _EmployeeId: {
      get() {
        if (this.EmployeeId === "" || this.EmployeeId === null) {
          return "null";
        } else {
          return this.EmployeeId;
        }
      },
    },
    _IpAddress: {
      get() {
        if (this.Ip === "" || this.Ip === null) {
          return "null";
        } else {
          return this.Ip;
        }
      },
    },
  },
  mounted() {
    this.Fn_GetDataConsent();
    this.Fn_GetDataPolicy();
    this.Fn_GetDataConsentGroup();
  },
  methods: {
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    async Fn_ViewDetail(href) {
      this.DialogItem = [];
      this.loadingDownloadData = false;
      this.Fn_DialogGetData(href);
      this.DialogItem = href;
      this.$store.dispatch("SET_DATA_GENERAL_CONSENT", href);
      this.SelectDetailConsent = href;
      this.DialogLitDetail = true;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate2(date2) {
      if (!date2) return null;

      const [year, month, day] = date2.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate2(date2) {
      if (!date2) return null;

      const [month, day, year] = date2.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async Fn_GetDataConsent() {
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemsConsentData = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            // Toast.fire({
            //   icon: "error",
            //   title: error.response.data.ErrorMessage,
            // });
            this.$router.push("/profile");
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataPolicy() {
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemsPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            // Toast.fire({
            //   icon: "error",
            //   title: error.response.data.ErrorMessage,
            // });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataConsentGroup() {
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemsConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            // Toast.fire({
            //   icon: "error",
            //   title: error.response.data.ErrorMessage,
            // });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_Search(val) {

      if (val == "false") {
        this.Page = 1;
      }

      if (this.$refs.form.validate()) {
        this.ItemConsent = [];
        this.LoadingSearch = true;
        this.loadingDownloadData = true;
        this.enablefilter = true;
        var payload = {
          ConsentId: this._ConsentId,
          PolicyId: this._PolicyId,
          GroupId: this._GroupId,
          AccountId: this._OneAccountId,
          BusinessId: this.$cookies.get("BusinessId"),
          Email: this._Email,
          Idcard: this._IDCardNumber,
          Name: this._Name,
          Passport: this._Passport,
          Tel: this._Tel,
          FromDate: this._FromDate,
          ToDate: this._ToDate,
          Status: this.StatusSend,
          SourceSystem: this._SourceSystem,
          BizId: this._BizId,
          RoleAccount: this.$cookies.get("RoleAccountId"),
          IpAddress: this._IpAddress,
          SessionId: this._IdSession,
          EmployeeId: this._EmployeeId,
          AccessToken: this.$cookies.get("OneAccessToken"),
          Page: this.Page,
          PerPage: this.ItemPerPage,
        };
        this.DataLoadCSV = payload;
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };

        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "dashbord/SearchUseConsentV2",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.LoadingSearch = false;
            this.loadingDownloadData = false;

            if (response.data.Status === "OK") {
              this.ItemConsent = response.data.Message.AllDataConsent;
              this.PageDetail = response.data.Message.PageDetail;
              this.From = response.data.Message.PageDetail.From;
              this.To = response.data.Message.PageDetail.To;
              this.LastPage = response.data.Message.PageDetail.LastPage;
              this.TotalAll = response.data.Message.PageDetail.TotalAll;
              var index = this.From - 1;
              for (var item of this.ItemConsent) {
                index += 1;
                item.no = index;
                item.see_id = false;
              }
              if (this.ItemConsent.length == 0) {
                this.loaddisCSV = true;
              } else {
                this.loaddisCSV = false;
              }
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSearch = false;
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    fn_seeEmailAnalysis(item) {
      if (item.see_id === true) {
        const objIndex = this.ItemConsent.findIndex(
          (arr) => arr.no === item.no
        );
        const objdata = this.ItemConsent.find((arr) => arr.no === item.no);
        objdata.see_id = false;
        this.ItemConsent.splice(objIndex, 1, objdata);
      } else if (item.see_id === false) {
        const objIndex = this.ItemConsent.findIndex(
          (arr) => arr.no === item.no
        );
        const objdata = this.ItemConsent.find((arr) => arr.no === item.no);
        objdata.see_id = true;
        this.ItemConsent.splice(objIndex, 1, objdata);
      }
    },
    async Fn_DownloadCSV() {
      this.loadCSV = true;
      var payload = {
        AdminAccountId: this.$cookies.get("OneAccountId"),
        ConsentId: this._ConsentId,
        PolicyId: this._PolicyId,
        GroupId: this._GroupId,
        AccountId: this._OneAccountId,
        BusinessId: this.$cookies.get("BusinessId"),
        Email: this._Email,
        Idcard: this._IDCardNumber,
        Name: this._Name,
        Passport: this._Passport,
        Tel: this._Tel,
        FromDate: this._FromDate,
        ToDate: this._ToDate,
        Status: this.StatusSend,
        SourceSystem: this._SourceSystem,
        BizId: this._BizId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
        IpAddress: this._IpAddress,
        SessionId: this._IdSession,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "report/Export/User/Consent",
          { Data: dataEncode },
          { responseType: "arraybuffer", headers }
        )
        .then((response) => {
          this.loadCSV = false;
          if (response.statusText == "OK") {
            const blob = new Blob([response.data], {
              type: "application/xlsx",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Search Consent" + ".xlsx";
            link.click();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadCSV = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_DialogGetData(val) {
      this.loadingDownloadData = true;

      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        SendId: val.SendId,
        Type: val.Type,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/GetConsentId",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") + error.message || error,
            });
          }
        });
    },
  },
  watch: {
    date(val) {
      this.FromDate = this.formatDate2(this.date);
      var date = new Date(this.FromDate);
      date.setDate(date.getDate() + 90);
      this.TodateMax = date.toISOString().substr(0, 10);
    },
    date2(val) {
      this.ToDate = this.formatDate2(this.date2);
    },
    $route(to) {
      document.title = `APPLICATION_NAME - ${to.meta.title}`;
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", to.meta.icon);
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
/* .text-tatble >>> .v-data-table td {
  width: 100%;
  max-width: 500px;
  overflow-x: auto;
} */
/* .th-stlye >>> .v-data-table th {
  text-align: center !important;
  color: #077893 !important;
} */
/* .th-first >>> .v-data-table th:first-child {
  border-radius: 5px 0 0 5px;
  width: 100%;
  max-width: 500px;
  overflow-x: auto;
} */

/* .th-last >>> .v-data-table th:last-child {
  border-radius: 0 5px 5px 0;
  width: 100%;
  max-width: 500px;
  overflow-x: auto;
} */
</style>
